import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Users, MagnifyingGlass, Eye } from "@phosphor-icons/react";
import api from "@/lib/api";
import { initials } from "@/lib/format";
import { Input } from "@/components/ui/input";
import { Pager } from "@/components/Pager";

export default function AdminCustomers() {
  const [list, setList] = useState(null);
  const [error, setError] = useState(false);
  const [q, setQ] = useState("");
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(0);
  const nav = useNavigate();
  const PAGE = 10;

  const load = () => { setError(false); api.get("/admin/customers", { params: { ...(q ? { q } : {}), limit: PAGE, offset: page * PAGE } }).then((r) => { setList(r.data.items); setTotal(r.data.total); }).catch(() => { setError(true); setList([]); }); };
  useEffect(() => { load(); }, [q, page]); // eslint-disable-line
  useEffect(() => { setPage(0); }, [q]);

  return (
    <div className="space-y-5">
      <h1 className="font-display font-bold text-3xl flex items-center gap-2"><Users size={26} className="text-primary" /> Customers</h1>
      <div className="relative max-w-md">
        <MagnifyingGlass size={18} className="absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground" />
        <Input data-testid="customer-search" value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search name, OneKite ID or phone…" className="pl-10 bg-muted/40 border-black/10 h-11 rounded-xl" />
      </div>

      <div className="card-surface overflow-hidden">
        <table className="w-full text-sm">
          <thead className="text-muted-foreground text-xs uppercase tracking-wider border-b border-black/8"><tr><th className="text-left p-4">Customer</th><th className="text-left p-4 hidden sm:table-cell">OneKite ID</th><th className="text-right p-4">Merchants</th><th className="text-right p-4">Status</th><th className="text-right p-4"></th></tr></thead>
          <tbody>
            {!list && <tr><td colSpan={5} className="p-6 text-center text-muted-foreground">Loading…</td></tr>}
            {error && <tr><td colSpan={5} className="p-6 text-center text-muted-foreground">Couldn't load customers.</td></tr>}
            {list && !error && list.length === 0 && <tr><td colSpan={5} className="p-6 text-center text-muted-foreground">No customers found.</td></tr>}
            {list && list.map((c) => (
              <tr key={c.id} data-testid="admin-customer-row" role="button" tabIndex={0} onClick={() => nav(`/admin/customers/${c.id}`)} onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); nav(`/admin/customers/${c.id}`); } }} className="border-b border-black/5 hover:bg-black/5 cursor-pointer focus:outline-none focus:bg-primary/5">
                <td className="p-4 flex items-center gap-3"><div className="h-9 w-9 rounded-lg bg-primary/15 flex items-center justify-center font-display font-bold text-primary text-xs">{initials(c.full_name)}</div>{c.full_name}</td>
                <td className="p-4 font-mono text-muted-foreground hidden sm:table-cell">{c.onekite_id}</td>
                <td className="p-4 text-right">{c.merchants}</td>
                <td className="p-4 text-right"><span className={`text-xs px-2 py-1 rounded-full ${c.status === "active" ? "text-emerald-700 bg-emerald-600/10" : "text-destructive bg-destructive/10"}`}>{c.status}</span></td>
                <td className="p-4 text-right"><span data-testid="view-customer-btn" className="inline-flex items-center gap-1 text-primary text-xs font-medium"><Eye size={15} /> View</span></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <Pager page={page} total={total} pageSize={PAGE} onPage={setPage} />
    </div>
  );
}
